function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17 20H13C12.4 20 12 19.6 12 19C12 18.4 12.4 18 13 18H17C17.3 18 17.5 17.9 17.7 17.7C17.9 17.5 18 17.3 18 17V3C18 2.7 17.9 2.5 17.7 2.3C17.5 2.1 17.3 2 17 2H13C12.4 2 12 1.6 12 1C12 0.4 12.4 0 13 0H17C17.8 0 18.6 0.3 19.1 0.9C19.7 1.4 20 2.2 20 3V17C20 17.8 19.7 18.6 19.1 19.1C18.5 19.6 17.8 20 17 20Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6 16C5.7 16 5.5 15.9 5.3 15.7L0.3 10.7C-0.1 10.3 -0.1 9.7 0.3 9.3L5.3 4.3C5.7 3.9 6.3 3.9 6.7 4.3C7.1 4.7 7.1 5.3 6.7 5.7L2.4 10L6.7 14.3C7.1 14.7 7.1 15.3 6.7 15.7C6.5 15.9 6.3 16 6 16Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13 11H1C0.4 11 0 10.6 0 10C0 9.4 0.4 9 1 9H13C13.6 9 14 9.4 14 10C14 10.6 13.6 11 13 11Z"
});

var SvgLogoutIcon = function SvgLogoutIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoutIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logout-icon.b63a7bba.svg";
export { ForwardRef as ReactComponent };